export enum AuthenticationType {
  Login = "Login",
  Register = "Register",
}
